export default [
  {
    value: "CHECK_CANCELLATION",
    key: "members.followUps.specialModificationCategories.checkCancellation",
  },
  {
    value: "TRANSFER_CANCELLATION",
    key: "members.followUps.specialModificationCategories.transferCancellation",
  },
  {
    value: "CHECK_REFUND",
    key: "members.followUps.specialModificationCategories.checkRefund",
  },
  {
    value: "BANK_TRANSFER_REFUND",
    key: "members.followUps.specialModificationCategories.bankTransferRefund",
  },
  {
    value: "WITHDRAWAL",
    key: "members.followUps.specialModificationCategories.withdrawal",
  },
  {
    value: "REINTEGRATION",
    key: "members.followUps.specialModificationCategories.reintegration",
  },
  {
    value: "MEMBER_ADDITION",
    key: "members.followUps.specialModificationCategories.memberAddition",
  },
  {
    value: "DEPENDENT_ADDITION",
    key: "members.followUps.specialModificationCategories.dependentAddition",
  },
  {
    value: "OTHER",
    key: "members.followUps.specialModificationCategories.other",
  },
];



// WEBPACK FOOTER //
// ./src/components/dashboard/clients/client/notes/enums/specialModificationCategories.js